import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  Paper,
  Stack,
  useTheme,
  Avatar,
  Modal,
  IconButton,
  styled,

} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EventIcon from '@mui/icons-material/Event';
import DescriptionIcon from '@mui/icons-material/Description';
import './Home.css';
import { Height } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close'; // Import Close Icon




const leadership = [
  {
    name: 'श्री.  राम गायकवाड',
    position: 'माननीय सरपंच',
    image: '/sarpanch.png',
  },
  {
    name: ' श्रीमती. सावित्री शिर्के',
    position: ' माननीय उपसरपंच ',
    image: '/vice_sarpanch.jpg',
  },
  {
    name: 'श्रीमती. स्नेहलता  बनसोडे  ',
    position: 'माननीय ग्रामसेवक ',
    image: '/gramsevak.jpg',
  },
];

const departments = [
  {
    name: 'कायदा सुव्यवस्था',
    icon: <i className="fas fa-scale-balanced"></i>, // Proper Law Icon
    submenu: [
      { name: 'पोलीस विभाग', icon: <i className="fas fa-shield-alt"></i> },
      { name: 'न्यायालय', icon: <i className="fas fa-gavel"></i> },
      { name: 'सुरक्षा उपाययोजना', icon: <i className="fas fa-user-shield"></i> },
    ],
  },
  {
    name: 'कुटुंब',
    icon: <i className="fas fa-users"></i>,
    submenu: [
      { name: 'परिवार कल्याण', icon: <i className="fas fa-heart"></i> },
      { name: 'महिला सशक्तिकरण', icon: <i className="fas fa-venus"></i> },
    ],
  },
  {
    name: 'शिक्षण',
    icon: <i className="fas fa-book-open"></i>, // Better Education Icon
    submenu: [
      { name: 'विद्यालय', icon: <i className="fas fa-school"></i> },
      { name: 'उच्च शिक्षण', icon: <i className="fas fa-university"></i> },
      { name: 'शिष्यवृत्ती', icon: <i className="fas fa-graduation-cap"></i> },
    ],
  },
  {
    name: 'कृषी',
    icon: <i className="fas fa-seedling"></i>,
    submenu: [
      { name: 'कृषी धोरणे', icon: <i className="fas fa-leaf"></i> },
      { name: 'सेंद्रिय शेती', icon: <i className="fas fa-tractor"></i> },
      { name: 'पीक विमा', icon: <i className="fas fa-file-invoice-dollar"></i> },
    ],
  },
  {
    name: 'सांस्कृतिक',
    icon: <i className="fas fa-theater-masks"></i>,
    submenu: [
      { name: 'संगीत', icon: <i className="fas fa-music"></i> },
      { name: 'कला', icon: <i className="fas fa-palette"></i> },
      { name: 'परंपरा', icon: <i className="fas fa-scroll"></i> },
    ],
  },
  {
    name: 'महसूल',
    icon: <i className="fas fa-landmark"></i>,
    submenu: [
      { name: 'भू-मालकी', icon: <i className="fas fa-map-marked-alt"></i> },
      { name: 'कर प्रणाली', icon: <i className="fas fa-coins"></i> },
      { name: 'ग्राम विकास', icon: <i className="fas fa-house-user"></i> },
    ],
  },
  {
    name: 'पर्यटन',
    icon: <i className="fas fa-globe-asia"></i>, // Correct Tourism Icon
    submenu: [
      { name: 'पर्यटन स्थळे', icon: <i className="fas fa-map"></i> },
      { name: 'हॉटेल्स', icon: <i className="fas fa-hotel"></i> },
      // { name: 'गाईड सेवा', icon: <i className="fas fa-user-tie"></i> },
    ],
  },
];

const Home: React.FC = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null); // ✅ Fixed Type
  const [showModal, setShowModal] = useState(false);
  const [showVideo, setShowVideo] = useState(false);


  useEffect(() => {
    // Check if user has already seen the intro
    const hasSeenIntro = localStorage.getItem('hasSeenIntro');

    if (!hasSeenIntro) {
      setShowModal(true); // Show modal for first-time visitors
      localStorage.setItem('hasSeenIntro', 'true'); // Store in localStorage
    }
  }, []);

  useEffect(() => {
    // Automatically start video after 2 seconds
    const textDelay = setTimeout(() => {
      setShowVideo(true);
    }, 3000);

    return () => clearTimeout(textDelay);
  }, []);

  const newsItems = [
    {
      title: 'Gram Sabha Meeting Announcement',
      date: '2024-02-10',
      description: 'Monthly Gram Sabha meeting will be held at Grampanchayat Hall.',
    },
    {
      title: 'New Water Supply Project',
      date: '2024-02-08',
      description: 'Implementation of 24x7 water supply project has been approved.',
    },
    {
      title: 'Swachh Bharat Abhiyan',
      date: '2024-02-05',
      description: 'Village cleanliness drive scheduled for next weekend.',
    },
  ];

  const schemes = [
    {
      title: 'PM Awas Yojana',
      image: 'pmj2.png',
      description: 'Housing scheme for rural residents',
    },
    {
      title: 'MNREGA',
      image: 'mg.png',
      description: 'Employment guarantee scheme',
    },
    {
      title: 'Swachh Bharat Mission',
      image: 'swach2.png',
      description: 'Clean India Mission',
    },
  ];

  const carouselItems = [
    { src: '/as.jpg', alt: 'Image 1' },
    { src: '/WWF/w1111.jpg', alt: 'Image 2', objectFit: 'cover'  },
    { src: '/WWF/w11111.jpg', alt: 'Image 3', objectFit: 'cover'},
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [carouselItems.length]);

  return (
    <div>

     {/* Modal Overlay */}
     <Modal open={showModal} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ textAlign: 'center', backgroundColor: 'rgba(0,0,0,0.7)', width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
          
          {/* Close Button (❌) to skip intro */}
          <IconButton
            sx={{
              position: 'absolute',
              top: 20,
              right: 20,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.8)' }
            }}
            onClick={() => setShowModal(false)}
          >
            <CloseIcon fontSize="large" />
          </IconButton>

          {/* Welcome Message */}
          {!showVideo && (
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'white', mb: 3, animation: 'fadeIn 2s ease-in-out' }}>
              🏡 किरकसाल ग्रामपंचायतीमध्ये आपले स्वागत आहे ! 🏡
            </Typography>
          )}

          {/* Village Introductory Video */}
          {showVideo && (
            <video
              src="/kirksal_introduction.mp4"
              autoPlay
              controls
              playsInline
              onEnded={() => setShowModal(false)} // Close modal after video ends
              style={{
                width: '80%',
                height: 'auto',
                borderRadius: '12px',
                boxShadow: '0px 10px 20px rgba(255, 255, 255, 0.3)',
                transform: 'perspective(1000px) rotateY(5deg)',
              }}
            />
          )}
        </Box>
      </Modal>

       

      {/* Carousel */}
      <div className="carousel">
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <img src={carouselItems[currentIndex].src} alt={carouselItems[currentIndex].alt} style={{ height: '400px', width: '100%', objectFit: 'cover' }} />
        </div>
      </div>

        {/* Leadership Section Center Bottom - Mobile Responsive */}
      <Box className="leadership-container center-bottom">
        {leadership.map((leader, index) => (
          <Box key={index} className="leader-card">
            <Box className="leader-image-box left-align">
              <Avatar src={leader.image} alt={leader.name} className="leader-avatar" />
            </Box>
            <Box className="leader-info">
              <Typography className="leader-name" align="center">{leader.name}</Typography>
              <Typography className="leader-position" align="center">{leader.position}</Typography>
            </Box>
          </Box>
        ))}
      </Box>

        {/* Departments Navigation */}
      <Box className="departments-nav">
        {departments.map((dept, index) => (
          <Box
            key={index}
            className={`department-item ${index === 0 ? 'first-dept' : ''} ${index === departments.length - 1 ? 'last-dept' : ''}`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <span className="dept-icon">{dept.icon}</span>
            <Typography variant="h6" className="dept-text">
              {dept.name}
            </Typography>

            {/* Submenu appears ABOVE the navigation */}
            {hoveredIndex === index && (
              <Box className={`submenu-container ${index === 0 ? 'first-submenu' : ''} ${index === departments.length - 1 ? 'last-submenu' : ''}`}>
                <Paper className="submenu-box">
                  <Grid container spacing={2}>
                    {dept.submenu.map((item, subIndex) => (
                      <Grid item xs={12} sm={4} key={subIndex} className="submenu-item-container">
                        <Button className="submenu-item">
                          {item.icon} <span className="submenu-text">{item.name}</span>
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                </Paper>
              </Box>
            )}
          </Box>
        ))}
      </Box>
      
    </div>
  );
};

export default Home;
